import { CardElement, Elements, PaymentElement, useElements } from '@stripe/react-stripe-js';
import Typography from '../../Typography';
import { Stripe } from '@stripe/stripe-js';
import StripeCheckOutForm, { StripeCheckOutFormRef } from '../../StripeCheckOutForm';
import React, { useRef } from 'react';
import Button from '../../Button';
import { useDispatch, useSelector } from 'react-redux';
import { StoreState } from '../../../../../store/reducer-main';
import { toast } from 'react-toastify';
import { finalizeStripePaymentMethodCreation, getPaymentMehods } from '../../../../../service/common/stripe';
import { extractStripePaymentMethodIdFromEvent } from '../../../../../helpers/stripeUtils';
import { loadPaymentMethod } from '../../../../../store/profile/slice';


interface Props{
  stripeElement:Stripe | null,
  onPaymentElementChange?:(e:any)=>void,
  paymentMethodModal:any,
  clientSecret:string|undefined
}

export default function ModifyPayemntMethodModaContent({stripeElement,onPaymentElementChange,paymentMethodModal,clientSecret}:Props) {

  const checkoutRef = React.createRef<StripeCheckOutFormRef>();
  const dispatch = useDispatch()

  const { userProfile } = useSelector((state: StoreState) => state.profile);

  const [isLoading,setIsLoading]= React.useState<boolean>(false)

  const updatePaymentMethod =async (
    stripeIntent:Stripe | null
    ) => {
      setIsLoading(true)
      try {
        if(stripeIntent && userProfile && checkoutRef.current && checkoutRef.current.paymentElements){
          const _newCard = await stripeIntent.confirmSetup({
            elements:checkoutRef.current.paymentElements,
            confirmParams: {
            },
            redirect: 'if_required',
          });
          if(_newCard.error)throw new Error("Invalid new Card")
          const paymnetMethodId=extractStripePaymentMethodIdFromEvent(_newCard.setupIntent.payment_method)
          const newpaymentMEthod =await finalizeStripePaymentMethodCreation(paymnetMethodId,userProfile.stripeCustomer.id);
          console.log(newpaymentMEthod.data)
          dispatch(loadPaymentMethod(newpaymentMEthod.data))
          toast.success("Carta modificata con successo!")
          paymentMethodModal.onClose()
        }else{
          toast.error("Errore interno , per favore riprova tra poco")
          setIsLoading(false)
        }
      } catch (error) {
        toast.error("Errore nella modifica della carta")
        console.log("errore nella modifica della carta",error)
        setIsLoading(false)
        }
  }

    return (
      <div className='my-4' >
        <div className='my-5'></div>
        <Elements stripe={stripeElement} 
                  options={{
                  clientSecret,
                  appearance: {
                    theme: 'stripe',
                    labels: 'floating',
                    },
                }}> 
            <StripeCheckOutForm ref={checkoutRef} onPaymentElementChange={onPaymentElementChange}  />
          </Elements>
          <Button disabled={isLoading} className='my-10' style={{width:"100%"}} onClick={()=>updatePaymentMethod(stripeElement)} title='Modifica'/>
      </div>  
    );
 }
